import { ageLabel, ageMs, connection } from "../observation";
import { useStats } from "../observations";

const TONE = {
  default: "bg-mesh-panel text-mesh-mute",
  ok: "bg-mesh-ok/20 text-mesh-ok",
  warn: "bg-mesh-warn/20 text-mesh-warn",
  err: "bg-mesh-err/20 text-mesh-err",
};
export default function HealthBadge() {
  const state = useStats();
  const health = connection(state);
  return (
    <span role="status" data-testid="mesh-health"
      title={state.data ? `Reported indexer ~${Math.max(0, Math.round(state.data.indexer_lag_ms / 1000))}s behind at last API observation ${ageLabel(ageMs(state))}; node connection as reported, not independently verified${state.error ? `; ${state.error}` : ""}` : "Waiting for the explorer API"}
      className={`px-2 py-1 rounded text-xs whitespace-nowrap ${TONE[health.tone]}`}>
      {health.label === "live" ? "●" : "◷"} {health.label}
    </span>
  );
}
